import React from 'react';

interface LogoProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  showText?: boolean;
  variant?: 'default' | 'standalone' | 'minimal';
}

const Logo: React.FC<LogoProps> = ({ 
  className = '', 
  size = 'md', 
  showText = false,
  variant = 'default'
}) => {
  // Logo height reduced by 25% from original sizes
  const sizeClasses = {
    sm: 'h-28', // 112px - reduced from 144px (25% smaller)
    md: 'h-36', // 144px - reduced from 192px (25% smaller)
    lg: 'h-44', // 176px - reduced from 240px (25% smaller)
    xl: 'h-52'  // 208px - reduced from 288px (25% smaller)
  };

  const textSizeClasses = {
    sm: 'text-sm',
    md: 'text-base', 
    lg: 'text-lg',
    xl: 'text-xl'
  };

  const containerClasses = variant === 'standalone' 
    ? `flex flex-col items-center p-4 bg-white rounded-lg shadow-lg ${className}`
    : `flex flex-col items-center ${className}`;

  return (
    <div className={containerClasses}>
      {/* Logo Image Container - maintains aspect ratio */}
      <div className={`${sizeClasses[size]} flex items-center justify-center`}>
        <img
          src="/zbm_logo.jpeg" // ZBM Projects logo file
          alt="ZBM Projects Logo"
          className="max-w-full max-h-full object-contain drop-shadow-sm"
          style={{
            width: 'auto',
            height: '100%',
            maxWidth: '100%',
            maxHeight: '100%'
          }}
          onError={(e) => {
            console.error('Failed to load logo:', '/zbm_logo.jpeg');
            e.currentTarget.style.display = 'none';
          }}
          onLoad={() => {
            console.log('Successfully loaded logo:', '/zbm_logo.jpeg');
          }}
        />
      </div>
      
      {/* Text Below Logo - only show if showText is true */}
      {showText && (
        <div className={`flex items-center space-x-1 mt-2 ${textSizeClasses[size]}`}>
          <span className="text-zbm-primary font-bold">ZBM</span>
          <span className="text-zbm-primary font-bold">Projects</span>
        </div>
      )}
    </div>
  );
};

export default Logo;